import { Pipe, PipeTransform } from '@angular/core';

import { CssUtils } from '../helpers/css-utils';

@Pipe({
  name: 'pxToRem'
})
export class PxToRemPipe implements PipeTransform {
  transform(value: string | number): string {
    return value && CssUtils.pxToRem(value);
  }
}
